/** * * Asynchronously loads the component for
Webhook
* */ import { lazyLoad } from 'utils/loadable';
export const Webhook = lazyLoad(() => import('./index'));
